<!-- Politique de confidentialité (RGPD, art. 13).
     Les champs .todo-placeholder sont à remplir par l'association. -->
<template>
  <div>
    <Navbar />
    <div class="legal-page">
      <el-card shadow="always" class="legal-card">
        <template #header>
          <h1>Politique de confidentialité</h1>
          <p class="legal-updated">Dernière mise à jour : 1er novembre 2026</p>
        </template>

        <h2>Responsable du traitement</h2>
        <p>
          <span class="todo-placeholder">[À COMPLÉTER : nom de l'association]</span>, éditrice de Wedoomotion
          (voir les <router-link to="/mentions-legales">mentions légales</router-link>).
          Pour toute question sur vos données : <span class="todo-placeholder">[À COMPLÉTER : contact@domaine]</span>.
        </p>

        <h2>Données collectées</h2>
        <ul>
          <li><strong>Compte</strong> : nom d'utilisateur, adresse e-mail, mot de passe (stocké uniquement sous forme chiffrée, jamais en clair), photo de profil, date d'inscription, rôle, date d'acceptation des présentes conditions.</li>
          <li><strong>Contenus</strong> : publications, images, commentaires, « j'aime », centres d'intérêt choisis.</li>
          <li><strong>Échanges</strong> : relations d'amitié, messages privés, messages et ressources partagés dans les groupes d'entraide.</li>
          <li><strong>Modération</strong> : signalements que vous effectuez (motif et précisions), notifications que vous recevez.</li>
          <li><strong>Journal de connexion</strong> : nom d'utilisateur et adresse e-mail utilisés, adresse IP, date et heure de début et de fin de chaque connexion.</li>
          <li><strong>Technique</strong> : un cookie de session et les journaux du serveur (adresse IP, date, page demandée).</li>
        </ul>
        <p>Les contenus que vous publiez peuvent révéler des informations sensibles (santé, convictions…) : ne partagez que ce que vous acceptez de rendre visible aux autres membres.</p>

        <h2>Finalités et base légale</h2>
        <p>
          Vos données servent uniquement à faire fonctionner Wedoomotion : créer et sécuriser votre compte,
          afficher vos contenus, permettre les échanges entre membres, vous envoyer le code de validation par e-mail
          et modérer la communauté. Ce traitement repose sur l'exécution des
          <router-link to="/cgu">conditions générales d'utilisation</router-link> que vous acceptez à l'inscription.
          Aucune donnée n'est vendue, ni utilisée à des fins publicitaires.
        </p>
        <p>
          Le journal de connexion, et la conservation de votre nom d'utilisateur et de votre adresse e-mail après la
          suppression du compte, répondent à une obligation légale de l'hébergeur (article 6 de la loi pour la confiance
          dans l'économie numérique, décret n° 2021-1362) : permettre d'identifier l'auteur d'un contenu à la demande
          des autorités. Voir l'article 7 des <router-link to="/cgu">conditions générales d'utilisation</router-link>.
        </p>

        <h2>Durées de conservation</h2>
        <ul>
          <li>Compte non validé : supprimé automatiquement quelques minutes après l'inscription.</li>
          <li>Compte validé : conservé tant que vous ne le supprimez pas.</li>
          <li>Session de connexion : expire après 10 minutes d'inactivité.</li>
          <li>Journal de connexion : un an à compter de chaque connexion, puis effacé automatiquement.</li>
          <li>À la suppression du compte, votre profil, vos publications, vos « j'aime », vos centres d'intérêt, vos messages privés, vos amitiés, vos signalements, vos notifications et vos contributions aux groupes d'entraide (adhésions, messages, ressources) sont effacés ; vos commentaires restent affichés sans votre nom d'utilisateur. Seuls votre nom d'utilisateur, votre adresse e-mail, votre journal de connexion et le lien entre vos commentaires et ces données sont conservés, un an au plus, au titre de l'obligation légale ci-dessus, puis effacés. Si vous êtes le seul modérateur d'un groupe d'entraide, transférez d'abord sa modération.</li>
        </ul>

        <h2>Destinataires</h2>
        <p>
          Les données sont accessibles aux seuls membres de l'équipe Wedoomotion qui en ont besoin (administration et modération)
          et à notre hébergeur OVH SAS, sous-traitant, qui les héberge dans l'Union européenne.
          Les contenus que vous publiez sont visibles des autres membres.
          Le journal de connexion n'est communiqué qu'aux autorités judiciaires ou administratives qui en font la
          demande dans le cadre prévu par la loi.
        </p>

        <h2>Cookies</h2>
        <p>
          Wedoomotion n'utilise qu'un seul cookie, <code>connect.sid</code>, qui maintient votre connexion.
          Strictement nécessaire au service, il est exempté de consentement : aucun cookie de mesure d'audience,
          de publicité ou de réseau social n'est déposé, c'est pourquoi aucun bandeau ne vous est présenté.
        </p>

        <h2>Vos droits</h2>
        <ul>
          <li><strong>Accès et portabilité</strong> : bouton « Télécharger mes données » sur votre profil (fichier JSON).</li>
          <li><strong>Rectification</strong> : modification de votre pseudo, mot de passe et photo depuis votre profil.</li>
          <li><strong>Effacement</strong> : bouton « Supprimer mon compte » sur votre profil.</li>
          <li><strong>Opposition, limitation</strong> et toute autre demande : par e-mail à <span class="todo-placeholder">[À COMPLÉTER : contact@domaine]</span>, réponse sous un mois.</li>
        </ul>
        <p>
          Si vous estimez que vos droits ne sont pas respectés, vous pouvez adresser une réclamation à la CNIL
          (<a href="https://www.cnil.fr/fr/plaintes" target="_blank" rel="noopener">www.cnil.fr</a>).
        </p>

        <nav class="legal-links">
          <router-link to="/mentions-legales">Mentions légales</router-link>
          <router-link to="/cgu">Conditions générales d'utilisation</router-link>
        </nav>
      </el-card>
    </div>
  </div>
</template>

<script>
import '@/styles/legal.css'
import Navbar from '@/components/Navbar.vue'

export default {
  name: 'PrivacyPolicy',
  components: {
    Navbar,
  },

  mounted() {
    document.body.style.backgroundColor = 'rgba(21, 109, 123)'
  },
}
</script>
